import {animate, state, style, transition, trigger} from '@angular/animations';
import {ChangeDetectionStrategy, Component, ContentChild, Input, TemplateRef} from '@angular/core';

@Component({
	selector: 'ic-progress-chart-component',
	templateUrl: './progress-chart.component.html',
	styleUrls: ['./progress-chart.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	animations: [
		trigger('coloring', [
			state('in', style({width: '*'})),
			transition('void => *', [style({width: '0'}), animate(1000, style({width: '*'}))])
		])
	],
	standalone: false
})
export class ProgressChartComponent {
	@Input() start = 0;
	@Input() end: number;
	@Input() intervals: {step: number; color: string}[];
	@Input() value: number;
	@ContentChild('title', {static: false}) title: TemplateRef<any>;
	@ContentChild('legend', {static: false}) legend: TemplateRef<any>;
	animationDone = false;

	determineColor() {
		for (const interval of this.intervals) {
			if (this.value < interval.step) {
				return interval.color;
			}
		}
	}

	getWidth() {
		const width = this.end - this.start;

		return width === 0 ? '0' : `${(this.value / width) * 100}%`;
	}

	onAnimationDone() {
		this.animationDone = true;
	}
}
